import { SystemStyleObject, default as systemCss } from '@styled-system/css';
import { SolvCSSObject } from '../theme/systemTypes';
import { SolvTheme } from '../theme/theme';

/**
 * Takes a set of system styles and resolve them to a css object
 * @param styles The styles to convert
 * @returns a css object
 */
export function style(styles: SolvCSSObject): any {
  const transformed: SystemStyleObject = {
    ...styles,
    // @ts-expect-error
    color: styles.textColor ?? styles.color ?? undefined,
  };
  // @ts-expect-error
  delete transformed.textColor;
  return systemCss(transformed)({ theme: SolvTheme });
}

function taggedTemplateNoop(strings: TemplateStringsArray, ...keys: any[]) {
  const lastIndex = strings.length - 1;
  return (
    strings.slice(0, lastIndex).reduce((p, s, i) => p + s + keys[i], '') +
    strings[lastIndex]
  );
}
/**
 * This is a noop string tag. It takes a string and returns the same string.
 * It exists to let you have nice syntax highlighting in your editor.
 *
 * @example styled.div(css`color: blue;`)
 */
export const css = taggedTemplateNoop;
